// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46')
];

export const server_loads = [3,4];

export const dictionary = {
		"/": [5],
		"/api-test": [~22],
		"/(app)/app": [6,[2]],
		"/auth/callback": [23],
		"/(app)/blocked": [7,[2]],
		"/(app)/capture": [8,[2]],
		"/(app)/chart/[type]": [9,[2]],
		"/(app)/dashboard": [10,[2]],
		"/dev": [24,[3]],
		"/dev/components/blocked/BlockedScreen": [25,[3]],
		"/dev/components/dashboard/AccountDetailsModal": [26,[3]],
		"/dev/components/dashboard/FeedbackModal": [27,[3]],
		"/dev/components/dashboard/ProductionChart": [28,[3]],
		"/dev/components/dashboard/SubmissionSuccessModal": [29,[3]],
		"/dev/components/submission/HelpScreen": [30,[3]],
		"/dev/components/submission/ImagePreview": [31,[3]],
		"/dev/components/submission/ManualEntry": [32,[3]],
		"/dev/components/submission/OcrProcessing": [33,[3]],
		"/dev/components/submission/OcrSuccess": [34,[3]],
		"/dev/components/submission/PhotoConfirmation": [35,[3]],
		"/dev/components/submission/PhotoUpload": [36,[3]],
		"/dev/components/transactions/TransactionStatementsTab": [37,[3]],
		"/dev/components/ui/ButtonFooter": [38,[3]],
		"/dev/components/ui/DatePicker": [39,[3]],
		"/dev/components/ui/LoadingScreen": [40,[3]],
		"/dev/components/ui/MonthYearPicker": [41,[3]],
		"/dev/components/ui/PageHeader": [42,[3]],
		"/dev/dashboard": [43,[3]],
		"/dev/routing/post-auth": [44,[3,4]],
		"/dev/start-submission": [45,[3]],
		"/dev/test-users": [46,[3]],
		"/(app)/meter-reading/camera-info": [12,[2]],
		"/(app)/meter-reading/camera": [11,[2]],
		"/(app)/meter-reading/manual": [13,[2]],
		"/(app)/meter-reading/photo-review": [14,[2]],
		"/(app)/meter-reading/review": [15,[2]],
		"/(app)/meter-reading/upload-info": [17,[2]],
		"/(app)/meter-reading/upload": [16,[2]],
		"/(app)/meter-reading/verify": [18,[2]],
		"/(app)/start-submission": [19,[2]],
		"/(app)/transactions": [20,[2]],
		"/(app)/walkthrough": [21,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);